import { defineStore } from 'pinia'
import { Station } from '../types/stationTypes'
import { fetchDestinationSuggestions } from '../services/journeyService'

interface TravelSearchState {
  origin: string
  destination: string
  OriginStation: Station
  destinationStation: Station
  destinationSuggestions: string[]
  departureDate: string
  returnDate: string
  allStations: Station[]
}

const createEmptyStation = (): Station => ({
  name: '',
  _u_i_c_station_code: '',
})

export const useTravelSearchStore = defineStore('travelSearch', {
  state: (): TravelSearchState => ({
    origin: '',
    destination: '',
    OriginStation: createEmptyStation(),
    destinationStation: createEmptyStation(),
    destinationSuggestions: [],
    departureDate: new Date().toISOString().split('T')[0],
    returnDate: '',
    allStations: [],
  }),

  actions: {
    setOriginDestination(origin: string, destination: string) {
      this.origin = origin
      this.destination = destination
    },

    reset() {
      this.origin = ''
      this.destination = ''
    },

    async setOriginStation(station: Station) {
      this.OriginStation = station
      this.origin = station.name || ''
      this.destinationSuggestions = []

      try {
        this.destinationSuggestions = await fetchDestinationSuggestions(station._u_i_c_station_code)
      } catch (error) {
        console.error('Error fetching destination suggestions:', error)
      }
    },

    setDestinationStation(station: Station) {
      this.destinationStation = station
      this.destination = station.name || ''
    },

    setDepartureDate(date: string) {
      this.departureDate = date
    },

    setReturnDate(date: string | null) {
      this.returnDate = date ?? ''
    },

    setAllStations(stations: Station[]) {
      this.allStations = stations
    },
  },

  getters: {
    mappedDestinationSuggestions: (state) => {
      const suggestions = state.destinationSuggestions || []
      return suggestions.map((uicCode) => {
        const matchedStation = state.allStations.find(
          (station: Station) => station._u_i_c_station_code === uicCode,
        )
        return {
          uicCode,
          name: matchedStation ? matchedStation.name : uicCode,
          sequence_number: matchedStation ? matchedStation.sequence_number : 100,
          district: matchedStation?.district,
          county: matchedStation?.county,
        }
      })
    },
  },
})
